export default __webpack_public_path__ + "static/media/rotation-mobility.7b317aeb.jpg";